import { render } from "./BoardInspectorControls.vue?vue&type=template&id=30733d3f&scoped=true"
import script from "./BoardInspectorControls.vue?vue&type=script&lang=js"
export * from "./BoardInspectorControls.vue?vue&type=script&lang=js"

import "./BoardInspectorControls.vue?vue&type=style&index=0&id=30733d3f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30733d3f"]])

export default __exports__